function getNewValue(theme, val) {
    let newval = Array.isArray(val) ? [] : null;
    if (Array.isArray(val)) {
        val.forEach((info) => {
            newval.push(getNewObjVal(theme, info))
        })
    }
    return newval
}
/**
 * 这里打包后图片都要放在img文件夹下，否则图片路径会出错
 * @param {*} theme 
 * @param {*} info 
 * @returns 
 */
function getNewObjVal(theme, info) {
    let path = ["group"]
    for (let key in info) {
        if (typeof info[key] == 'string' && (info[key].indexOf(".svg") != -1 || info[key].indexOf(".png") != -1)) {
            let type = info[key].indexOf(".svg") != -1 ? 'svg' : 'png';
            const themePath = info[key].split('/img/')[1].split(type)[0].split(".")[0];
            if (themePath.indexOf('orange') != -1) {
                let path = themePath.split('_')
                var themeImg = path.slice(0, path.length - 1).join("_") + theme;
            } else {
                theme = theme == "_blue" ? '' : theme
                var themeImg = themePath + theme;
            }
            path.forEach((info) => {
                if (themeImg.indexOf(info) != -1) {
                    themeImg = `${path}/${themeImg}`
                }
            })
            if (type == 'svg') {
                info[key] = require(`@/svg/${themeImg}.svg`)
            } else {
                info[key] = require(`@/${themeImg}.png`)
            }
        }
    }
    return info
}

export const getTheme = (val) => {
    let theme = document.querySelector('html').getAttribute("data-theme") ?? 'blue';
    theme = theme == 'Blue' ? '' : `_${theme.toLocaleLowerCase()}`
    console.log(theme, 'theme')
    return getNewValue(theme, val)
}

let imgOrSvg = {
    docMid: {
        node: ".doc-mid>.blank>img",
        blueSrc: require("@/assets/images/blank/blank.png"),
        orangeSrc: require("@/assets/images/blank/blank_orange.png")
    },
    blankWrapper: {
        node: '.blank-wrapper>.blank>img',
        blueSrc: require("@/assets/images/blank/blank.png"),
        orangeSrc: require("@/assets/images/blank/blank_orange.png")
    },
}
let clickReplaceImgObj = {
    "文档": {
        node: ".doc-mid>.blank>img",
        blueSrc: require("@/assets/images/blank/blank.png"),
        orangeSrc: require("@/assets/images/blank/blank_orange.png")
    },
    doc: {
        node: ".doc-mid>.blank>img",
        blueSrc: require("@/assets/images/blank/blank.png"),
        orangeSrc: require("@/assets/images/blank/blank_orange.png")
    },
    goods: { //商品   需要打开弹框更新
        node: '.el-table__empty-text>.blank>img',
        blueSrc: require("@/assets/images/blank/blank.png"),
        orangeSrc: require("@/assets/images/blank/blank_orange.png")
    },
    recomed: {  //推荐，需要打开弹框更新
        node: '.el-table__empty-text>.blank>img',
        blueSrc: require("@/assets/images/blank/shangpin.png"),
        orangeSrc: require("@/assets/images/blank/shangpin_orange.png")
    },
    "gonggao": {
        node: '.el-table__empty-text>.blank>img',
        blueSrc: require("@/assets/images/blank/gonggao.png"),
        orangeSrc: require("@/assets/images/blank/gonggao_orange.png")
    },
    "公告": {
        node: '.el-table__empty-text>.blank>img',
        blueSrc: require("@/assets/images/blank/gonggao.png"),
        orangeSrc: require("@/assets/images/blank/gonggao_orange.png")
    },
    "抽奖记录": {
        node: '.blank-wrapper>.blank>img',
        blueSrc: require("@/assets/images/blank/blank.png"),
        orangeSrc: require("@/assets/images/blank/blank_orange.png")
    },
    "商品": {
        node: '.el-table__empty-text>.blank>img',
        blueSrc: require("@/assets/images/blank/shangpin.png"),
        orangeSrc: require("@/assets/images/blank/shangpin_orange.png")
    },
    "shangpin": {
        node: '.el-table__empty-text>.blank>img',
        blueSrc: require("@/assets/images/blank/shangpin.png"),
        orangeSrc: require("@/assets/images/blank/shangpin_orange.png")
    },
    reward: {
        node: '.no-reward>img',
        blueSrc: require("@/svg/no-reward.svg"),
        orangeSrc: require("@/svg/no-reward_orange.svg")
    },
    "审核": {
        node: '.el-dialog__body>img',
        blueSrc: require("@/assets/images/blank/liaotianshenhe.png"),
        orangeSrc: require("@/assets/images/blank/liaotianshenhe_orange.png")
    },
    multimedia: {
        node: '.el-table__empty-text>.blank>img',
        blueSrc: require("@/assets/images/blank/duomeiti.png"),
        orangeSrc: require("@/assets/images/blank/duomeiti_orange.png")
    },
    "多媒体": {
        node: '.el-table__empty-text>.blank>img',
        blueSrc: require("@/assets/images/blank/duomeiti.png"),
        orangeSrc: require("@/assets/images/blank/duomeiti_orange.png")
    },
    // "0":{
    //     node: '.no-reward>img',
    //     blueSrc: require("@/svg/no-reward.svg"),
    //     orangeSrc: require("@/svg/no-reward_orange.svg")
    // }
}
export function setImgOrSvg() {
    const theme = document.querySelector('html').getAttribute("data-theme")
    setTimeout(() => {
        for (let key in imgOrSvg) {
            const imgNode = document.querySelector(imgOrSvg[key].node);
            if (imgNode && imgNode.src) {
                imgNode.src = imgOrSvg[key][`${theme.toLocaleLowerCase()}Src`]
            }
        }
    }, 40)
}
function setOneImgOrSvg(key) {
    const theme = document.querySelector('html').getAttribute("data-theme") ?? 'blue';
    var curTimer = null, curTime = 0;
    curTimer = setInterval(() => {
        const imgNode = document.querySelector(clickReplaceImgObj[key].node);
        curTime++
        if (imgNode && imgNode.src && curTime != 80) {
            imgNode.src = clickReplaceImgObj[key][`${theme.toLocaleLowerCase()}Src`];
            
        }
        if (curTime == 80) {
            clearInterval(curTimer)
        }
    }, 10)
}

// 监听点击事件：如何点击事件弹框包含需要替换的主题图标则替换
export function addEventClick() {
    setImgOrSvg()
    document.addEventListener('click', (event) => {
        // console.log(event, '123344444')
        let replaceMark = event.target.currentSrc || event.target.innerText || event.target.innerHTML;
        if (replaceMark == "推荐") {
            replaceMark = "recomed"
        }
        if (!replaceMark) return;
        for (let key in clickReplaceImgObj) {
            if (replaceMark.indexOf(key) != -1) {
                console.log(key,'replaceMark')
                setOneImgOrSvg(key);
                return
            }
        }
    }, true)
}

